import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchDashboardReport, fetchRatingData } from "../../actions/summary";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import moment from "moment";
import AccessPage from "../Shared/accessPage";
import Splinechart from "../common/splinechart";
import Loader from "../Shared/loader";
import imgOne from "../../assets/images/Browser-Key--Streamline-Core.png";
import imgTwo from "../../assets/images/Login-Setting-Bolt-Nut--Streamline-Core.png";
import imgThree from "../../assets/images/Programming-Code-Block--Streamline-Core.png";
import imgFour from "../../assets/images/Laptop-Search--Streamline-Core.png";
import imgFive from "../../assets/images/Inbox-Content--Streamline-Core.png";
import imgSix from "../../assets/images/Id-Card--Streamline-Rounded-Material.png";
import imgSeven from "../../assets/images/Bug-Virus-Browser--Streamline-Sharp.png";
import imgEight from "../../assets/images/Cloud-Remove--Streamline-Sharp.png";
import imgNine from "../../assets/images/Dark-Dislay-Mode--Streamline-Sharp.png";
import imgTen from "../../assets/images/Telegram-Logo--Streamline-Sharp.png";
import imgEleven from "../../assets/images/Crown-Circle--Streamline-Sharp.png";

var Model = require("./model");

const Dashboard = () => {
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const [loading, setLoading] = useState(false);
  const [isModal, setModal] = useState('');
  const [graphTime, setGraphTime] = useState('');
  const [riskScoreVA, setRiskScoreVa] = useState("");
  const [riskScoreExpiredSSL, setRiskScoreExpiredSSL] = useState("");
  const [riskScoreVulnerableSSL, setRiskScoreVulnerableSSL] = useState("");
  const [riskScoreDangling, setRiskScoreDangling] = useState("");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  // Move useSelector declarations before useEffect hooks
  let summary = useSelector((state) => state?.summary?.dashboardSummary);
  let summaryLoading = useSelector((state) => state?.summary?.loading);
  let ratingData = useSelector((state) => state?.summary?.ratingData);

  useEffect(() => {
    if (id) {
      fetchDashboardReport(id, "Data", dispatch);
    } else {
      fetchDashboardReport(id, "Data", dispatch);
    }
  }, [id]);

  // Add debugging logs
  useEffect(() => {
  }, [summaryLoading, summary, ratingData]);
  
  useEffect(() => {
    if (id) {
      fetchRatingData(id, graphTime, dispatch);
    }
  }, [id, graphTime]);

  // Transform the data into valid x,y coordinates
  const prepareChartData = () => {
    if (!ratingData?.ratings || !Array.isArray(ratingData.ratings)) return { values: [], dates: [] };

    const validData = ratingData.ratings
      .filter(row => row?.createdAt && row?.darkWebSecurityImpact !== undefined)
      .map(row => ({
        value: Number(row.darkWebSecurityImpact) || 0,
        date: moment(row.createdAt).format("DD-MM-YYYY")
      }));

    return {
      values: validData.map(point => point.value),
      dates: validData.map(point => point.date)
    };
  };

  const chartData = prepareChartData();
  const hasValidChartData = chartData.values.length > 0 && chartData.dates.length > 0;

  
  // Get total score from rating data
  const totalScore = ratingData?.totalScoreDashboard?.darkWebSecurityImpact || 0;

  const generateReport = () => {
    if (loading) {
      return false;
    }
    setLoading(true);
    let data = {
      id: id,
      asm: 'darkweb'
    }

    // Make sure your Model.default.generateReport includes { responseType: 'blob' }
    Model.default.generateReport(data)
      .then((response) => {
        setLoading(false);
        if (!response.error) {
          try {
            // Use the response data directly as it should already be a blob
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${clientName?.replace(/\s+/g, '-') || 'report'}-DarkWeb.docx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } catch (e) {
            // console.error removed
          }
        }
      })
      .catch(error => {
        setLoading(false);
        // console.error removed
      });
  };

  const getArrow = (val) => {
    if (val > 0) return "fa fa-arrow-up fa-1x arrowRed";
    else return "fa fa-arrow-down fa-1x arrowGreen";
  };
  // End of generate grade for danglong domains

  return (
    <div className="container-fluid">
      <AccessPage></AccessPage>
      {/* {(summaryLoading || loading) && (
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      )} */}
      {!summaryLoading && !loading && !summary && (
        <div className="text-center">
          <Loader />
        </div>
      )}
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Summary</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  Data Exposure Details
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
            <span
              className="btn btn-sm btn-primary mr-1 download-report"
              onClick={() => generateReport()}
            >
              Download Report
            </span>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-9">
          <div className="card">
            <div className="body" style={{ minHeight: "380px" }}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6>Data Exposure Health Tracker</h6>
                    <select 
                      className="form-control" 
                      style={{ width: 'auto', backgroundColor: '#fff', color: 'white', border: '1px solid #444' }}
                      onChange={(e) => {
                        setGraphTime(e.target.value);
                      }}
                    >
                      <option value="">Select Time Period</option>
                      <option value="7days">Last 7 days</option>
                      <option value="1month">Last 30 days</option>
                      <option value="3months">Last 3 months</option>
                      
                    </select>
                  </div>
                  {hasValidChartData && (
                    <Splinechart
                      value={chartData.values}
                      date={chartData.dates}
                      name={`Data Exposure Score: ${totalScore}`}
                      color="#08283f"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card">
            <div className="body" style={{ minHeight: "380px" }}>
              <h6 className="welcome-text">Top Issues</h6>
              <div className="list-group">
                {summary?.issueArray?.slice(0, 3)?.map((row) => (
                  <Link
                    to={row?.link}
                    className="list-group-item list-group-item-action list-group-item-newUpdate"
                    style={{ color: "white" }}
                  >
                    {row?.msg}
                  </Link>
                ))}
                {summary?.issueArray?.length > 3 &&
                  (
                    <span className="text-center mt-3"
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex"
                      }}
                    >
                      <a
                        onClick={() => {
                          setModal('Form Wizard modal')
                        }}
                        style={{
                          float: "right",
                          color: "#fff",
                        }}
                        className="btn btn-primary"
                      >
                        <i
                          className="fa fa-file-excel-o"
                          style={{ color: "#fff" }}
                        ></i>{" "}
                        View All
                      </a>
                    </span>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {id && (
        <>
          <div className="row clearfix" id="summaryBox2">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="row clearfix">
                <div className="col-sm-2">
                  <span className="card mb-3">
                    <Link
                      to={`/stolen-credentials${vendorId ? '/vendor/' + vendorId : ''}`}
                    >
                      <div
                        className="card w_card3 m-0 Dcards"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="body">
                          <div className="text-center">
                            <span className="iconBoxDashboard">
                              <img src={imgOne} className="img-fluid" />
                            </span>
                            <h5 className="m-t-20 mb-0">
                              {summary?.LeakCredential || 0}
                            </h5>
                            <p className="text-muted1">Stolen Credentials</p>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div>
                            <span className="text-muted1">
                              {!(summaryLoading || loading) ? (
                                <span className="dashboardFirstHeading">
                                  {summary?.stolenCredentialScanDifference &&
                                    summary?.stolenCredentialScanDifference !== 0 ? (
                                    <i
                                      className={getArrow(
                                        summary?.stolenCredentialScanDifference
                                      )}
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                  {Math.abs(summary?.stolenCredentialScanDifference || 0)}{" "}
                                  v/s last scan
                                </span>
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </span>
                </div>

                <div className="col-sm-2">
                  <span className="card mb-3">
                    <Link
                      to={`/leaked-sessions${vendorId ? '/vendor/' + vendorId : ''}`}
                    >
                      <div
                        className="card w_card3 m-0 Dcards"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="body">
                          <div className="text-center">
                            <span className="iconBoxDashboard">
                              <img src={imgTwo} className="img-fluid" />
                            </span>
                            <h5 className="m-t-20 mb-0">
                              {summary?.LeakedSession || 0}
                            </h5>
                            <p className="text-muted1">Leaked Sessions</p>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div>
                            <span className="text-muted1">
                              {!(summaryLoading || loading) ? (
                                <span className="dashboardFirstHeading">
                                  {summary?.leakedSessionScanDifference &&
                                    summary?.leakedSessionScanDifference !== 0 ? (
                                    <i
                                      className={getArrow(
                                        summary?.leakedSessionScanDifference
                                      )}
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                  {Math.abs(
                                    summary?.leakedSessionScanDifference || 0
                                  )}{" "}
                                  v/s last scan
                                </span>
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </span>
                </div>

                <div className="col-sm-2">
                  <span className="card mb-3">
                    <Link
                      to={`/source-code${vendorId ? '/vendor/' + vendorId : ''}`}
                    >
                      <div
                        className="card w_card3 m-0 Dcards"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="body">
                          <div className="text-center">
                            <span className="iconBoxDashboard">
                              <img src={imgThree} className="img-fluid" />
                            </span>

                            <h5 className="m-t-20 mb-0">
                              {summary?.SourceCode || 0}
                            </h5>
                            <p className="text-muted1">Source Code Leakage</p>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div>
                            <span className="text-muted1">
                              {!(summaryLoading || loading) ? (
                                <span className="dashboardFirstHeading">
                                  {summary?.sourceCodeScanDifference &&
                                    summary?.sourceCodeScanDifference !== 0 ? (
                                    <i
                                      className={getArrow(
                                        summary?.sourceCodeScanDifference
                                      )}
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                  {Math.abs(
                                    summary?.sourceCodeScanDifference || 0
                                  )}{" "}
                                  v/s last scan
                                </span>
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </span>
                </div>
                <div className="col-sm-2">
                  <span className="card mb-3">
                    <Link
                      to={`/pastebin-search${vendorId ? '/vendor/' + vendorId : ''}`}
                    >
                      <div
                        className="card w_card3 m-0 Dcards"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="body">
                          <div className="text-center">
                            <span className="iconBoxDashboard">
                              <img src={imgFour} className="img-fluid" />
                            </span>
                            <h5 className="m-t-20 mb-0">
                              {summary?.PasteBin || 0}
                            </h5>
                            <p className="text-muted1">Pastebin Search</p>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div>
                            <span className="text-muted1">
                              {!(summaryLoading || loading) ? (
                                <span className="dashboardFirstHeading">
                                  {summary?.pasteBinScanDifference &&
                                    summary?.pasteBinScanDifference !== 0 ? (
                                    <i
                                      className={getArrow(
                                        summary?.pasteBinScanDifference
                                      )}
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                  {Math.abs(summary?.pasteBinScanDifference || 0)} v/s
                                  last scan
                                </span>
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </span>
                </div>
                <div className="col-sm-2">
                  <span className="card mb-3">
                    <Link
                      to={`/postman-monitoring${vendorId ? '/vendor/' + vendorId : ''}`}
                    >
                      <div
                        className="card w_card3 m-0 Dcards"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="body">
                          <div className="text-center">
                            <span className="iconBoxDashboard">
                              <img src={imgFive} className="img-fluid" />
                            </span>
                            <h5 className="m-t-20 mb-0">
                              {summary?.PostmanMonitoring || 0}
                            </h5>
                            <p className="text-muted1">Postman Monitoring</p>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div>
                            <span className="text-muted1">
                              {!(summaryLoading || loading) ? (
                                <span className="dashboardFirstHeading">
                                  {summary?.postmanScanDifference &&
                                    summary?.postmanScanDifference !== 0 ? (
                                    <i
                                      className={getArrow(
                                        summary?.postmanScanDifference
                                      )}
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                  {Math.abs(summary?.postmanScanDifference || 0)} v/s
                                  last scan
                                </span>
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </span>
                </div>
                <div className="col-sm-2">
                  <span className="card mb-3">
                    <Link
                      to={`/pii${vendorId ? '/vendor/' + vendorId : ''}`}
                    >
                      <div
                        className="card w_card3 m-0 Dcards"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="body">
                          <div className="text-center">
                            <span className="iconBoxDashboard">
                              <img src={imgSix} className="img-fluid" />
                            </span>
                            <h5 className="m-t-20 mb-0">
                              {summary?.personalData || 0}
                            </h5>
                            <p className="text-muted1">Personal Information</p>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div>
                            <span className="text-muted1">
                              {!(summaryLoading || loading) ? (
                                <span className="dashboardFirstHeading">
                                  {summary?.personalInformationScanDifference &&
                                    summary?.personalInformationScanDifference !== 0 ? (
                                    <i
                                      className={getArrow(
                                        summary?.personalInformationScanDifference
                                      )}
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                  {Math.abs(summary?.personalInformationScanDifference || 0)} v/s
                                  last scan
                                </span>
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </span>
                </div>
                <div className="col-sm-2">
                  <span className="card mb-3">
                    <Link to={`/malware-credentials${vendorId ? '/vendor/' + vendorId : ''}`} >
                      <div className="card w_card3 m-0 Dcards" style={{ cursor: "pointer" }}>
                        <div className="body">
                          <div className="text-center">
                            <span className="iconBoxDashboard">
                              <img src={imgSeven} className="img-fluid" />
                            </span>
                            <h5 className="m-t-20 mb-0">
                              {summary?.MalwareCredential || 0}
                            </h5>
                            <p className="text-muted1">Malware Infected Machines</p>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div>
                            <span className="text-muted1">
                              {!(summaryLoading || loading) ? (
                                <span className="dashboardFirstHeading">
                                  {summary?.malwareInfectedScanDifference &&
                                    summary?.malwareInfectedScanDifference !== 0 ? (
                                    <i
                                      className={getArrow(summary?.malwareInfectedScanDifference)}
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                  {Math.abs(summary?.malwareInfectedScanDifference || 0)} v/s last
                                  scan
                                </span>
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </span>
                </div>
                {id && (
                  <div className="col-sm-2">
                    <span className="card mb-3">
                      <Link to={`/cloud-bucket${vendorId ? '/vendor/' + vendorId : ''}`}>
                        <div className="card w_card3 m-0 Dcards" style={{ cursor: "pointer" }}>
                          <div className="body">
                            <div className="text-center">
                              <span className="iconBoxDashboard">
                                <img src={imgEight} className="img-fluid" />
                              </span>
                              <h5 className="m-t-20 mb-0">
                                {summary?.CloudBucket || 0}
                              </h5>
                              <p className="text-muted1">Cloud Storage</p>
                            </div>
                          </div>
                          <div className="card-footer">
                            <div>
                              <span className="text-muted1">
                                {!(summaryLoading || loading) ? (
                                  <span className="dashboardFirstHeading">
                                    {summary?.cloudStorageScanDifference &&
                                      summary?.cloudStorageScanDifference !== 0 ? (
                                      <i
                                        className={getArrow(summary?.cloudStorageScanDifference)}
                                      ></i>
                                    ) : (
                                      ""
                                    )}
                                    {Math.abs(summary?.cloudStorageScanDifference || 0)} v/s last
                                    scan
                                  </span>
                                ) : (
                                  ""
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </span>
                  </div>
                )}
                {id && (
                  <div className="col-sm-2">
                    <span className="card mb-3">
                      <Link to={`/dark-web${vendorId ? '/vendor/' + vendorId : ''}`}>
                        <div className="card w_card3 m-0 Dcards" style={{ cursor: "pointer" }}>
                          <div className="body">
                            <div className="text-center">
                              <span className="iconBoxDashboard">
                                <img src={imgNine} className="img-fluid" />
                              </span>
                              <h5 className="m-t-20 mb-0">
                                {summary?.DarkWeb || 0}
                              </h5>
                              <p className="text-muted1">Dark Web Monitoring</p>
                            </div>
                          </div>
                          <div className="card-footer">
                            <div>
                              <span className="text-muted1">
                                {!(summaryLoading || loading) ? (
                                  <span className="dashboardFirstHeading">
                                    {summary?.darkWebScanDifference &&
                                      summary?.darkWebScanDifference !== 0 ? (
                                      <i
                                        className={getArrow(summary?.darkWebScanDifference)}
                                      ></i>
                                    ) : (
                                      ""
                                    )}
                                    {Math.abs(summary?.darkWebScanDifference || 0)} v/s last
                                    scan
                                  </span>
                                ) : (
                                  ""
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </span>
                  </div>

                )}
                {id && (
                  <div className="col-sm-2">
                    <span className="card mb-3">
                      <Link to={`/telegram-monitoring${vendorId ? '/vendor/' + vendorId : ''}`}>
                        <div className="card w_card3 m-0 Dcards" style={{ cursor: "pointer" }}>
                          <div className="body">
                            <div className="text-center">
                              <span className="iconBoxDashboard">
                                <img src={imgTen} className="img-fluid" />
                              </span>
                              <h5 className="m-t-20 mb-0">
                                {summary?.Telegram || 0}
                              </h5>
                              <p className="text-muted1">Telegram Monitoring</p>
                            </div>
                          </div>
                          <div className="card-footer">
                            <div>
                              <span className="text-muted1">
                                {!(summaryLoading || loading) ? (
                                  <span className="dashboardFirstHeading">
                                    {summary?.TelegramForumScanDifference &&
                                      summary?.TelegramForumScanDifference !== 0 ? (
                                      <i
                                        className={getArrow(summary?.TelegramForumScanDifference)}
                                      ></i>
                                    ) : (
                                      ""
                                    )}
                                    {Math.abs(summary?.TelegramForumScanDifference || 0)} v/s last
                                    scan
                                  </span>
                                ) : (
                                  ""
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </span>
                  </div>
                )}
                {/* {id && (
                  <div className="col-sm-2">
                    <span className="card mb-3">
                      <Link
                        to={`/vip-entities${vendorId ? '/vendor/' + vendorId : ''}`}
                      >
                        <div className="card w_card3 m-0 Dcards" style={{ cursor: "pointer" }}>
                          <div className="body">
                            <div className="text-center">
                              <span className="iconBoxDashboard">
                                <img src={imgEleven} className="img-fluid" />
                              </span>
                              <h5 className="m-t-20 mb-0">
                                {summary?.totalVipEntityAlerts || 0}
                              </h5>
                              <p className="text-muted1">VIP Monitoring</p>
                            </div>
                          </div>
                          <div className="card-footer">
                            <div>
                              <span className="text-muted1">
                                {!(summaryLoading || loading) ? (
                                  <span className="dashboardFirstHeading">
                                    {0 !== 0 ? (
                                      <i
                                        className={getArrow(
                                          0
                                        )}
                                      ></i>
                                    ) : (
                                      ""
                                    )}
                                    {Math.abs(summary?.totalVipEntityAlertsScanDifference || 0)} v/s
                                    last scan
                                  </span>
                                ) : (
                                  ""
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </span>
                  </div>
                )} */}
              </div>
            </div>
            <div
              className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
                }`}
            >
              <div className="modal-dialog modal-lg" id="clientModal">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Top Issues
                    </h5>
                    <button
                      type="button"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => setModal("")}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body pricing_page">
                    <div className="card">
                      <div className="body">
                        <div className="list-group">
                          {summary?.issueArray?.map((row) => (
                            <Link
                              to={row?.link}
                              className="list-group-item list-group-item-action list-group-item-newUpdate"
                              style={{ color: "white" }}
                            >
                              {row?.msg}
                            </Link>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default Dashboard;
